if (!customElements.get('tab-switcher')) {
  customElements.define(
    'tab-switcher',
    class TabSwitcher extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.tabPrefix = this.dataset.prefix;
        this.tabs = this.querySelectorAll(`.${this.tabPrefix}tab`);
        this.tabItems = this.querySelectorAll(`.${this.tabPrefix}tab-item`);
        this.tabList = this.querySelector(`.${this.tabPrefix}tab-list`);

        this.isAnimated = this.dataset.isAnimated === 'true';

        this.tabItems.forEach((it) => {
          const btn = it.querySelector(`.${this.tabPrefix}tab-btn`);
          const tab = this.querySelector(`#${btn.dataset.tabTarget}`);

          btn.addEventListener('click', this.onTabSwitch.bind(this, it, tab));
        });

        // Balayage tactile (opt-in via data-swipe) : passer d'un onglet à l'autre
        // au doigt sur la zone de contenu, sans gêner le scroll vertical de la page.
        if (this.dataset.swipe === 'true') {
          this.initSwipe();
        }
      }

      initSwipe() {
        const content = this.querySelector(`.${this.tabPrefix}tabs-content`);
        if (!content) return;

        let startX = 0;
        let startY = 0;

        content.addEventListener(
          'touchstart',
          (e) => {
            startX = e.changedTouches[0].clientX;
            startY = e.changedTouches[0].clientY;
          },
          { passive: true },
        );

        content.addEventListener(
          'touchend',
          (e) => {
            const dx = e.changedTouches[0].clientX - startX;
            const dy = e.changedTouches[0].clientY - startY;

            // Ignore les gestes trop courts ou plus verticaux qu'horizontaux.
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;

            const items = [...this.tabItems];
            const current = items.findIndex((it) =>
              it.classList.contains(`${this.tabPrefix}tab-item--active`),
            );
            const next = dx < 0 ? current + 1 : current - 1;
            if (next < 0 || next >= items.length) return;

            items[next].querySelector(`.${this.tabPrefix}tab-btn`).click();
          },
          { passive: true },
        );
      }

      scrollActiveIntoView(item) {
        if (!this.tabList) return;

        const btn = item.querySelector(`.${this.tabPrefix}tab-btn`);
        if (!btn) return;

        const target = btn.offsetLeft - (this.tabList.clientWidth - btn.clientWidth) / 2;
        this.tabList.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }

      onTabSwitch(item, tab) {
        this.tabItems.forEach((it) => it.classList.remove(`${this.tabPrefix}tab-item--active`));
        this.tabs.forEach((t) => t.classList.remove(`${this.tabPrefix}tab--active`));

        if (this.isAnimated) {
          setTimeout(() => {
            tab.classList.remove(`${this.tabPrefix}tab--slide-left`);
            tab.classList.remove(`${this.tabPrefix}tab--slide-right`);

            let isBefore = true
            for (const tabElm of this.tabs) {
              if (tabElm === tab) {
                isBefore = false;
                continue;
              }

              tabElm.classList.toggle(`${this.tabPrefix}tab--slide-left`, isBefore);
              tabElm.classList.toggle(`${this.tabPrefix}tab--slide-right`, !isBefore);
            }
          }, 200);
        }

        item.classList.add(`${this.tabPrefix}tab-item--active`);
        tab.classList.add(`${this.tabPrefix}tab--active`);

        if (this.dataset.swipe === 'true') {
          this.scrollActiveIntoView(item);
        }
      }
    },
  );
}
